var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenuStar(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "star"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.4416 2.92532L12.9083 5.85865C13.1083 6.26698 13.6416 6.65865 14.0916 6.73365L16.7499 7.17532C18.4499 7.45865 18.8499 8.69198 17.6249 9.90865L15.5583 11.9753C15.2083 12.3253 15.0166 13.0003 15.1249 13.4837L15.7166 16.042C16.1833 18.067 15.1083 18.8503 13.3166 17.792L10.8249 16.317C10.3749 16.0503 9.63326 16.0503 9.17492 16.317L6.68326 17.792C4.89992 18.8503 3.81659 18.0587 4.28326 16.042L4.87492 13.4837C4.98326 13.0003 4.79159 12.3253 4.44159 11.9753L2.37492 9.90865C1.15826 8.69198 1.54992 7.45865 3.24992 7.17532L5.90826 6.73365C6.34992 6.65865 6.88326 6.26698 7.08326 5.85865L8.54992 2.92532C9.34992 1.33365 10.6499 1.33365 11.4416 2.92532Z",
    stroke: "#585858",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_2",
    opacity: 0
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuStar);
export default __webpack_public_path__ + "static/media/menu-star.beefca04f2b71a37f719a52af416821e.svg";
export { ForwardRef as ReactComponent };